import React, { type ReactElement } from 'react';
import Icon from 'atom-components/icon';
import Table from 'atom-components/table-lite/table';
import TooltipItem from 'atom-components/tooltip-item';
import { friendlyMarkerName } from 'helpers/domain-specific/marker.helpers';
import type { BaseCustomerUser } from 'services/assist-api/entities/customer-user/types';
import type { ManageMarkingMarkItem } from 'services/assist-api/entities/test-instance-response-mark/types';
import type { TestInstanceResponseMarkerWithCustomerUser } from 'services/assist-api/entities/test-instance-response-marker/types';
import { TestInstanceResponseInputType } from 'services/assist-api/entities/test-instance-response/types';
import type { BaseTestRubricItem } from 'services/assist-api/entities/test-rubric-item/types';
import DeallocationResultsMarkerBadge from './deallocation-results-marker-badge';
import { allocatedMarkerTooltip } from './deallocation-results.helpers';

type Props = {
  markItem: ManageMarkingMarkItem;
  rubricItem: BaseTestRubricItem | undefined;
  allocatedMarkerId: number;
  activeMarker: TestInstanceResponseMarkerWithCustomerUser | undefined;
  organisationUser: BaseCustomerUser | undefined;
};

export default function MarkItem({
  markItem,
  rubricItem,
  allocatedMarkerId,
  activeMarker,
  organisationUser
}: Props): ReactElement {
  const allocatedMarkerIsMarker = markItem.testInstanceResponseMarker.id === allocatedMarkerId;
  const tooltip = allocatedMarkerTooltip(
    allocatedMarkerIsMarker,
    friendlyMarkerName(organisationUser),
    false
  );

  return (
    <Table.Row>
      <Table.DataCell>
        <TooltipItem tooltip={tooltip}>
          <Icon icon={allocatedMarkerIsMarker ? 'xmark' : 'check'} />
        </TooltipItem>
      </Table.DataCell>
      <Table.DataCell>{markItem.id}</Table.DataCell>
      <Table.DataCell>{rubricItem?.displayName || 'No Rubric Item set'}</Table.DataCell>
      <Table.DataCell>
        <DeallocationResultsMarkerBadge
          isMark={false}
          allocatedMarkerIsMarker={allocatedMarkerIsMarker}
          activeMarker={activeMarker}
          organisationUser={organisationUser}
          autoscored={markItem.inputType === TestInstanceResponseInputType.Ai}
        />
      </Table.DataCell>
    </Table.Row>
  );
}
